import React from 'react'

import { LntEmpty, LntFormItem, LntTextArea } from '@app/components/base'
import { Switch } from '@app/components/util'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { SIZE } from '@app/constants'

import { CommentsItem } from '../components/CommentsItem'

import styles from '../styles.module.scss'

import type { CommentsTabProps } from './types'

const { Case } = Switch

export const CommentsTab: React.FC<CommentsTabProps> = props => {
  const { data, onDeleteComment, onPatchComment } = props

  return (
    <>
      <div className={ styles.commentsTab__newComment }>
        <LntFormItem
          name='message'
          label='Дополнительный комментарий'
        >
          <LntTextArea
            showCount
            maxLength={ 250 }
            size={ SIZE.large }
            placeholder={ FILTERS_PLACEHOLDERS.comment }
          />
        </LntFormItem>
      </div>

      <div className={ styles.commentsTab__commentsList }>
        <Switch fallback={ <LntEmpty description='Комментариев пока нет' /> }>
          <Case condition={ !!data?.length }>
            { data?.map(item => (
              <CommentsItem
                key={ item.id }
                data={ item }
                onDeleteComment={ onDeleteComment }
                onPatchComment={ onPatchComment }
              />
            )) }
          </Case>
        </Switch>
      </div>
    </>
  )
}
